import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Tabs, Tab, Typography, Container } from "@mui/material";
import VendorRegistration from "../vendorCode/VendorRegistration";
import PropTypes from "prop-types";
import classes from "./MainPage.module.css";
import Login from "../vendorLogin/Login";
import Header from "../Dashboard/Header/Header";
import Footer from "../Dashboard/Footer/Footer";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MainPage = () => {
  const [value, setValue] = useState(0);
  const [searchParams] = useSearchParams();
  const isLoginTab = searchParams.get("Logintab");

  useEffect(() => {
    // Read the query parameter or state to determine which tab to display
    if (isLoginTab) {
      setValue(0); // Set the tab based on the query parameter or state
    }
  }, [isLoginTab]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#ececec",
        height: "100vh",
        // backgroundImage: "url(https://media.istockphoto.com/id/1078209068/vector/doodle-pattern-with-black-seamless-pattern-on-light-background-light-lamp-icon-vector-light.jpg?s=612x612&w=0&k=20&c=9A9p18oP0ZhzPKmHQB6CPigdyS9sO8veenGN75F4z1E=)",
        position: "relative",
        overflow: "auto",
        backgroundBlendMode: "screen",
      }}
    >
      <Header />
      <Container
        sx={{
          backgroundColor: "white",
          backgroundImage: "url(/assets/images/backgroundWater.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          borderRadius: "20px",
          width: { xs: "100%", sm: "97%", md: "87%", lg: "60%", xl: "57%" },
          padding: "30px",
          height: { xs: "90%", sm: "60%" },
          marginTop: { xs: "40px", sm: "150px" },
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.7)",
        }}
      >
        <Box>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            className={classes.Tab}
          >
            <Tab label="Login" {...a11yProps(0)} className={classes.Main} />
            <Tab
              label="New registration"
              {...a11yProps(1)}
              className={classes.Main}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Login />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <VendorRegistration />
        </TabPanel>
      </Container>
      <Footer />
    </Box>
  );
};

export default MainPage;
